import { render } from "./wx_mp_auth.vue?vue&type=template&id=1254fbe3&scoped=true"
import script from "./wx_mp_auth.vue?vue&type=script&lang=js"
export * from "./wx_mp_auth.vue?vue&type=script&lang=js"

import "./wx_mp_auth.vue?vue&type=style&index=0&id=1254fbe3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1254fbe3"]])

export default __exports__